import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger, } from "@/components/ui/dialog";
import { decodeHTMLEntity } from "@/lib/utils";
export default function FloorplanImageDialog(_a) {
    var floorplan = _a.floorplan;
    var floorplanTitle = decodeHTMLEntity(floorplan.title);
    return (React.createElement(Dialog, null,
        React.createElement(DialogTrigger, { "aria-label": "View floor plan image for ".concat(floorplanTitle) },
            React.createElement("img", { src: floorplan.floorplanImageURL || "", alt: floorplan.floorplanImageAltText || floorplanTitle, className: "p-4 w-auto max-h-[16rem] my-0 mx-auto" })),
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Floorplan"),
                React.createElement(DialogDescription, null, floorplanTitle)),
            React.createElement("img", { src: floorplan.floorplanImageURL || "", alt: floorplan.floorplanImageAltText || floorplanTitle, className: "w-full" }))));
}
